export const mapStripeErrors = message => {
  let errors = {};
  // INFO: Your card number is incorrect.
  if (message.includes('card number')) {
    errors['card_number'] = message;
  }
  // INFO: Your card's expiration month is invalid.
  if (message.includes('expiration month')) {
    errors['exp_month'] = message;
  }

  // TODO: Should be extended for cvc, month and year ...
  return errors;
};



// WEBPACK FOOTER //
// ./src/store/modules/utils/stripeErrorsMapper.js